let StarterCampaignTourSteps  = {
  tourSteps: function() {
    return [
      {
        content: 'The starter workflow page shows the details of the starter workflow.',
        target: '.help_icon_smaller',
        placement: 'bottom',
        disableBeacon: true
      },
      {
        content: 'This is the title of the starter workflow.',
        target: '.campaign_title',
        placement: 'bottom',
        disableBeacon: true
      },
      {
        content: 'Use this button to rename your starter workflow.',
        target: '.rename_campaign_btn',
        placement: 'bottom',
        disableBeacon: true
      },
      {
        content: 'This is the author of the starter workflow.',
        target: '.starter_campaign_meta_author',
        placement: 'bottom',
        disableBeacon: true
      },
      {
        content: 'This is the category of the starter workflow.',
        target: '.starter_campaign_meta_category',
        placement: 'bottom',
        disableBeacon: true
      },
      {
        content: 'This is the description of the starter workflow..',
        target: '.starter_campaign_meta_description',
        placement: 'bottom',
        disableBeacon: true
      },
      {
        content: 'This is the publish button. It only shows when you are working on a draft.',
        target: '.publish_btn',
        placement: 'top',
        disableBeacon: true
      },
      {
        content: "These are the steps in a starter workflow. You can drag the steps around to reorder them.",
        target: '.campaign_steps',
        placement: 'top',
        disableBeacon: true
      },
      {
        content: "This is the add step button.",
        target: '.add_step_btn',
        placement: 'top',
        disableBeacon: true
      },
      {
        content: "This is the amount to wait since the previous step in the starter workflow.",
        target: '.step_delay_group',
        placement: 'top'
      },
      {
        content: "This is the action used in this step of the starter workflow. You can pick a template, edit the current template, or create a new template.",
        target: '.step_action_group',
        placement: 'top',
        disableBeacon: true
      },
      {
        content: "This is the remove step button.",
        target: '.remove_step_btn',
        placement: 'top',
        disableBeacon: true
      },
      {
        content: "This back button will take you back to your starter workflows list.",
        target: '.campaigns_back',
        placement: 'top',
        disableBeacon: true
      },
      {
        content: "This is the starter workflow version select. It shows the current version of the starter workflow you are viewing. You can go back to any version of a starter workflow.",
        target: '.campaigns_version_select',
        placement: 'top',
        disableBeacon: true
      },
      {
        content: "This is the delete starter workflow button.",
        target: '.delete_campaign_btn',
        placement: 'top',
        disableBeacon: true
      },
      {
        content: "Click here to edit a starter workflow.",
        target: '.campaign_edit',
        placement: 'top',
        disableBeacon: true
      }];
  }
};

export default StarterCampaignTourSteps;
